export default __webpack_public_path__ + "static/media/down.2640059b.svg";